import { authHelper } from './auth';

globalThis.ikea = globalThis.ikea ?? {};
globalThis.ikea.mvAgent = globalThis.ikea.mvAgent ?? {};
globalThis.ikea.mvAgent.authentication = authHelper();
